import { render, staticRenderFns } from "./listTeachers.vue?vue&type=template&id=6bdfa9e6&"
import script from "./listTeachers.vue?vue&type=script&lang=js&"
export * from "./listTeachers.vue?vue&type=script&lang=js&"
import style0 from "./listTeachers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports